var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoblist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 32,
    viewBox: "0 0 82 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1101_950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2443 4.67673H9.55227V0H3.2443V4.67673ZM3.2443 24.3614C3.2443 26.4106 3.20884 27.0978 0.847257 27.0978C0.565271 27.1005 0.283365 27.087 0.00292969 27.0573V31.9156C0.814328 31.9502 1.66288 31.9873 2.47512 31.9873C7.93369 31.9873 9.55565 30.3341 9.55565 25.4016V7.05182H3.2443V24.3614Z",
    fill: "#97989E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1032 21.7332C15.669 21.7332 14.3038 19.7913 14.3038 16.3372C14.3038 12.9894 15.6682 11.0449 18.0306 11.0449C20.4994 11.0449 21.8647 12.9522 21.8647 16.2992C21.8647 19.7533 20.4994 21.7332 18.1024 21.7332H18.1032ZM18.1784 6.51172C12.1651 6.51172 8.03125 10.54 8.03125 16.3372C8.03125 22.201 12.1245 26.193 18.1024 26.193C24.0802 26.193 28.1364 22.163 28.1364 16.2992C28.1364 10.5071 24.0836 6.51172 18.1792 6.51172",
    fill: "#97989E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7146 21.2298C33.3175 21.2298 31.8796 19.3224 31.8796 16.1554C31.8796 13.1698 33.3564 11.265 35.6791 11.265C37.9698 11.265 39.4423 13.207 39.4423 16.1554C39.4423 19.2861 38.0069 21.2298 35.7163 21.2298H35.7146ZM43.6529 9.35599C42.1551 7.60917 39.9728 6.59843 37.6717 6.58575C35.2029 6.58575 33.5776 7.55842 32.0645 9.17868V0H25.8359V25.6169H31.8053V23.4216C33.3201 25.2597 34.6093 26.1235 37.231 26.1235C42.3586 26.0872 45.7502 22.167 45.7502 16.1604C45.7502 13.3176 45.0148 11.01 43.6504 9.36106",
    fill: "#97989E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7989 0.00195312H44.5264V25.6188H50.7989V0.00195312Z",
    fill: "#97989E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.752 4.6058H56.0194V0H49.752V4.6058ZM49.752 25.6186H56.0194V7.05182H49.752V25.6186Z",
    fill: "#97989E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.144 14.8596C67.2628 14.2094 65.3445 13.8464 63.3916 13.4546C62.4324 13.2385 60.9177 13.0958 60.9177 11.8377C60.9177 10.8625 61.806 10.3239 63.4271 10.3239C65.2001 10.3239 66.2302 10.8305 66.4886 12.4836H72.2435C72.0206 7.91499 68.0016 6.51172 63.6103 6.51172C57.8933 6.51172 54.7584 8.56512 54.7584 12.3063C54.7584 14.6071 56.0476 16.2282 58.4844 17.0557C59.6985 17.45 61.1018 17.8156 63.4659 18.2808C66.009 18.8178 66.6743 19.2155 66.6743 20.2227C66.6743 21.4132 65.5649 22.1292 63.7969 22.1292C61.8034 22.1292 60.477 21.5205 60.3292 19.5025H54.3877C54.6477 24.6529 59.0746 26.1237 63.65 26.1237C69.3644 26.1237 72.7957 23.7124 72.7957 19.7178C72.7957 17.3064 71.6137 15.7267 69.144 14.8638",
    fill: "#97989E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2241 11.0083V7.05093H77.314V1.36523H71.0432V7.05093H67.9082V11.0083H71.0432V19.6095C71.0432 24.3951 72.5908 25.8693 77.6458 25.8693C78.7147 25.8693 79.4941 25.8355 81.2241 25.6903V21.1917C80.6728 21.2508 80.1184 21.2744 79.5641 21.2626C77.39 21.2626 77.314 20.3997 77.314 18.6739V11.0083H81.2241Z",
    fill: "#97989E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1101_950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoblist);
export default __webpack_public_path__ + "static/media/joblist.a361834cfbbf3eec974d4459727d40ad.svg";
export { ForwardRef as ReactComponent };